import { useQuery } from 'data-fetching-client';
import * as React from 'react';
import { Text } from 'foundations-components/components/Text';
import UIFlex from 'UIComponents/layout/UIFlex';
import NoIdDefaultLabel from 'flow-doctor-lib/components/common/NoIdDefaultLabel';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import { CRM_SEARCH_BY_ID_FIELD_NAME, GET_CRM_SEARCH_OBJECT_BY_ID } from 'flow-doctor-lib/queries/CrmObjectQueries';
import { getIdentifierPropertyForObject, getIdentifiersForContactProfile } from 'flow-doctor-lib/utils/objectUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ObjectProfileLabel = ({
  portalId,
  objectTypeId,
  objectId,
  showId = false,
  tag
}) => {
  var _data$CRM_SEARCH_BY_I;
  const {
    loading,
    error,
    data
  } = useQuery(GET_CRM_SEARCH_OBJECT_BY_ID, {
    variables: {
      portalId: Number(portalId),
      objectTypeId,
      objectId: objectId.toString()
    }
  });
  if (error) {
    return /*#__PURE__*/_jsx(NoIdDefaultLabel, {
      objectId: objectId
    });
  }
  if (loading || !data) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  }
  const objectResponse = (_data$CRM_SEARCH_BY_I = data[CRM_SEARCH_BY_ID_FIELD_NAME]) === null || _data$CRM_SEARCH_BY_I === void 0 || (_data$CRM_SEARCH_BY_I = _data$CRM_SEARCH_BY_I.results) === null || _data$CRM_SEARCH_BY_I === void 0 ? void 0 : _data$CRM_SEARCH_BY_I[0];
  const objectLabel = objectTypeId === '0-1' && objectResponse ? getIdentifiersForContactProfile(objectResponse) : {
    primary: objectResponse ? getIdentifierPropertyForObject(objectResponse) : null,
    secondary: null
  };
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      children: [/*#__PURE__*/_jsxs(Text, {
        as: "h5",
        marginInlineEnd: "200",
        paddingBlock: "100",
        children: [objectLabel.primary, ' ', showId && /*#__PURE__*/_jsx(NoIdDefaultLabel, {
          objectId: objectId,
          parenthesize: true
        })]
      }), tag]
    }), objectLabel.secondary]
  });
};
export default ObjectProfileLabel;